import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface NavLink {
  label: string;
  path: string;
}

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-header',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() logoSrc: string = 'img/wescotcorplogo.png';
  @Input() brandName: string = 'Wescot Corp';
  @Input() contactEmail: string = 'wescotcorporation@wescot.com.co';
  @Input() contactPhone: string = '+00 61 426 037 898';
  @Input() navLinks: NavLink[] = [];
}
